import { useState, useEffect } from "react";
import axios from "axios";
import { Megaphone, X } from "lucide-react";

const ChangelogModal = () => {
  const [note, setNote] = useState(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    axios.get('/api/changelog/unseen')
      .then(res => {
        if (res.data) {
          setNote(res.data);
          setVisible(true);
        }
      })
      .catch(() => {});
  }, []);

  const handleClose = async () => {
    if (note) {
      try {
        await axios.post(`/api/changelog/${note.id}/mark-seen`);
      } catch (e) {}
    }
    setVisible(false);
  };

  if (!visible || !note) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-blue-500 p-5 text-white flex items-center gap-3">
          <div className="bg-white/20 p-2 rounded-lg">
            <Megaphone size={22} />
          </div>
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-blue-100">Pembaruan Sistem</div>
            <div className="font-bold text-lg">{note.title}</div>
          </div>
        </div>
        <div className="p-5 max-h-96 overflow-y-auto">
          <div className="text-xs text-gray-400 font-mono mb-3">Versi {note.version}</div>
          <ul className="space-y-2">
            {note.items.map((item, idx) => (
              <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                <span className="text-blue-500 mt-0.5">•</span>
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="p-4 border-t bg-gray-50 flex justify-end">
          <button
            onClick={handleClose}
            className="bg-blue-600 hover:bg-blue-700 text-white font-bold px-5 py-2 rounded-lg transition flex items-center gap-2"
          >
            <X size={16} />
            Mengerti
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangelogModal;
